module.exports = __webpack_public_path__ + "img/s.308a789c.jpg";